import { Input, LabeledContainer, Label } from './Labeled.client';

/**
 * Takes care of matching id and htmlFor attributes
 */
export const Labeled = {
	Container: LabeledContainer,
	Input: Input,
	Label: Label,
};
